import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'

function Blogdetail() {
  return (
    <div>
        <Header />
{/*           
        <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover"   style={{
    backgroundImage: "url('/assets/img/breadcrumb-bg.jpg')"
    
   
  }}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Blog Details</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="/">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                          Blog Details
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {/* <!-- GT News-standard Section Start --> */}
        <section class="news-standard-section section-padding">
            <div class="container">
                <div class="gt-news-details-wrapper">
                    <div class="row g-4">
                        <div class="col-12 col-lg-8">
                            <div class="gt-details-image">
                                <img src="/img/prop.png" alt="img"/>
                            </div>
                            <div class="gt-news-details-content">
                                <h3>Why Investing in a Shree JRB Property is a Smart Choice</h3>
                                <p>
                                  Investing in a Shree JRB property is more than just buying a home; it is securing a lifestyle of luxury, comfort, and financial growth. Shree JRB Group has earned a reputation for delivering high-quality homes that combine innovative architecture, durable construction, and aesthetic appeal. Every property is strategically located near essential hubs like schools, hospitals, shopping centers, and business districts, ensuring convenience in daily life.

Shree JRB homes are designed to enhance your living experience with spacious interiors, natural lighting, elegant finishes, and world-class amenities. Whether you are planning for a family or looking for a profitable investment, these properties provide long-term value, safety, and peace of mind. With thoughtful designs that cater to modern lifestyles and future growth, choosing a Shree JRB property is a step toward a brighter, more secure future.
                                </p>
                                <div class="gt-list">
                                    <div class="gt-list-item">
                                        <h3>Top Benefits:</h3>
                                        <ul class="gt-details-list">
                                            <li>
                                               <i class="flaticon-right-arrow"></i>
                                                 Trusted Brand with Years of Experience
                                            </li>
                                            <li>
                                               <i class="flaticon-right-arrow"></i>
                                              Prime Locations near Schools, Malls & Hospitals
                                            </li>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               Modern Architecture & Thoughtful Planning
                                            </li>
                                               <li>
                                              <i class="flaticon-right-arrow"></i>
                                              World-Class Amenities: Gym, Security, Play Areas
                                            </li>
                                               <li>
                                              <i class="flaticon-right-arrow"></i>
                                             Long-Term Property Appreciation
                                            </li>
                                        </ul>
                                    </div>
                                    {/* <div class="gt-list-item">
                                        <h3>2. Unleash the Beast Within</h3>
                                        <ul class="gt-details-list">
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               Your Only Limit is You
                                            </li>
                                            <li>
                                               <i class="flaticon-right-arrow"></i>
                                                 Invest in Statement Pieces
                                            </li>
                                            <li>
                                               <i class="flaticon-right-arrow"></i>
                                                Maximize Space with Smart Storage
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                                {/* <div class="gt-sideber">
                                    <h6>
                                        Buying my first home felt overwhelming, but their team made everything simple and stress-free. I found a beautiful home in my budget. Highly recommend their service!
                                    </h6>
                                    <div class="client-info-item">
                                        <div class="client-info">
                                            <div class="image">
                                                <img src="assets/img/home-1/news/client-1.png" alt="img"/>
                                            </div>
                                            <h4>Shikhon Islam</h4>
                                        </div>
                                        <div class="icon">
                                            <img src="assets/img/home-1/news/quote.png" alt="img"/>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div class="gt-list mb-0">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="gt-list-item">
                                                <h3>3.Maximize Space with Smart</h3>
                                                <ul class="gt-details-list">
                                                    <li>
                                                       <i class="flaticon-right-arrow"></i>
                                                        Sweat. Burn. Conquer.
                                                    </li>
                                                    <li>
                                                       <i class="flaticon-right-arrow"></i>
                                                        Fitness Reloaded
                                                    </li>
                                                    <li>
                                                       <i class="flaticon-right-arrow"></i>
                                                        Stronger Than Yesterday
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="gt-list-item">
                                                <h3>4. Conclusion</h3>
                                                <ul class="gt-details-list">
                                                    <li>
                                                       <i class="flaticon-right-arrow"></i>
                                                       Your Body. Your Gym. Your Rules.
                                                    </li>
                                                    <li>
                                                       <i class="flaticon-right-arrow"></i>
                                                        Crush Limits. Lift Dreams.
                                                    </li>
                                                    <li>
                                                       <i class="flaticon-right-arrow"></i>
                                                        Born to Lift. Trained to Win.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div class="row g-4">
                                    <div class="col-lg-6">
                                        <div class="gt-details-image">
                                            <img src="/img/map.jpg" alt="img"/>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="gt-details-image">
                                            <img src="/img/new2.jpeg" alt="img"/>
                                        </div>
                                    </div>
                                </div>
                                <h3 class="text">Ready for the Ride of a Lifetime?</h3>
                                <p>
                                    No matter your skill level, these legendary motorcycle routes offer unforgettable experiences. Pack your gear, fuel up, and hit the open road
                                </p>
                                {/* <div class="row gt-tag-share-wrap mt-4 mb-5">
                                    <div class="col-lg-8 col-12">
                                        <div class="tagcloud"> 
                                            <span>Tags:</span>                                  
                                            <a href="news-details.html">SmartHomes</a>
                                            <a href="news-details.html">LuxuryLiving</a>
                                            <a href="news-details.html">LegalAdvice</a>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-12 mt-3 mt-lg-0 text-lg-end">
                                        <div class="social-share">
                                            <a href="#"><i class="fab fa-twitter"></i></a>
                                            <a href="#"><i class="fa-brands fa-youtube"></i></a>
                                            <a href="#"><i class="fab fa-linkedin-in"></i></a> 
                                            <a href="#"><i class="fab fa-facebook-f"></i></a>    
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div class="gt-comments-area">
                                    <div class="gt-comments-heading">
                                        <h3>02 Comments</h3>
                                    </div>
                                    <div class="gt-blog-single-comment d-flex gap-4 pt-4 pb-4">
                                        <div class="image">
                                            <img src="assets/img/home-1/news/comment-1.png" alt="img"/>
                                        </div>
                                        <div class="gt-content">
                                            <div class="head d-flex flex-wrap gap-2 align-items-center justify-content-between">
                                                <div class="con">
                                                    <h5><a href="news-details.html">Leslie Alexander</a></h5>
                                                    <span>February 10, 2024 at 2:37 pm</span>
                                                </div>
                                                <a href="news-details.html" class="reply">Reply</a>
                                            </div>
                                            <p class="mt-30 mb-4">
                                                Neque porro est qui dolorem ipsum quia quaed inventor veritatis et quasi architecto var sed efficitur turpis gilla sed sit amet finibus eros. Lorem Ipsum is simply dummy
                                            </p>
                                        </div>
                                    </div>
                                    <div class="gt-blog-single-comment d-flex gap-4 pt-4 pb-4">
                                        <div class="image">
                                            <img src="assets/img/home-1/news/comment-2.png" alt="img"/>
                                        </div>
                                        <div class="gt-content">
                                            <div class="head d-flex flex-wrap gap-2 align-items-center justify-content-between">
                                                <div class="con">
                                                    <h5><a href="news-details.html">Joseph Michael</a></h5>
                                                    <span>February 10, 2024 at 2:37 pm</span>
                                                </div>
                                                <a href="news-details.html" class="reply">Reply</a>
                                            </div>
                                            <p class="mt-30 mb-4">
                                                Neque porro est qui dolorem ipsum quia quaed inventor veritatis et quasi architecto var sed efficitur turpis gilla sed sit amet finibus eros. Lorem Ipsum is simply dummy
                                            </p>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div class="gt-comment-form-wrap pt-5">
                                    <h3>Leave a comments</h3>
                                    <form action="#" id="contact-form" method="POST">
                                        <div class="row g-4">
                                            <div class="col-lg-6">
                                                <div class="form-clt">
                                                    <span>Your Name*</span>
                                                    <input type="text" name="name" id="name" placeholder="Your Name"/>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-clt">
                                                    <span>Your Email*</span>
                                                    <input type="text" name="email" id="email6" placeholder="Your Email"/>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="form-clt">
                                                    <span>Message*</span>
                                                    <textarea name="message" id="message" placeholder="Type your message"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                               <button type="submit" class="theme-btn">
                                                    SEND MESSAGE
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div> */}
                            </div>
                        </div>
                        {/* <div class="col-lg-4 col-12">
                            <div class="gt-main-sideber sticky-style">
                                <div class="gt-single-sideber-widget">
                                    <div class="gt-widget-title">
                                        <h3>All Categories</h3>
                                    </div>
                                    <ul class="gt-category-list">
                                        <li><a href="news-details.html">City Guide</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="news-details.html">New Places</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="news-details.html">Apartments </a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="news-details.html">Real estate  </a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="news-details.html">Luxury vilas  </a><span><i class="flaticon-right-arrow"></i></span></li>
                                    </ul>
                                </div>
                                <div class="gt-single-sideber-widget">
                                    <div class="gt-widget-title">
                                        <h3>Recent Post</h3>
                                    </div>
                                    <div class="gt-recent-post-area">
                                        <div class="gt-recent-items">
                                            <div class="gt-recent-thumb">
                                                <img src="assets/img/home-1/news/post-1.jpg" alt="img"/>
                                            </div>
                                            <div class="gt-recent-content">
                                                <h5>
                                                    <a href="news-details.html">
                                                        What to Know About Property Taxes Before You Buy
                                                    </a>
                                                </h5>
                                                <ul>
                                                    <li>
                                                        March 26, 2025
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="gt-recent-items">
                                            <div class="gt-recent-thumb">
                                                <img src="assets/img/home-1/news/post-2.jpg" alt="img"/>
                                            </div>
                                            <div class="gt-recent-content">
                                                <h5>
                                                    <a href="news-details.html">
                                                       Simple Home Upgrades That Boost Property Value
                                                    </a>
                                                </h5>
                                                <ul>
                                                    <li>
                                                        March 26, 2025
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="gt-recent-items">
                                            <div class="gt-recent-thumb">
                                                <img src="assets/img/home-1/news/post-3.jpg" alt="img"/>
                                            </div>
                                            <div class="gt-recent-content">
                                                <h5>
                                                    <a href="news-details.html">
                                                       What to Know About Property Taxes Before You Buy
                                                    </a>
                                                </h5>
                                                <ul>
                                                    <li>
                                                        March 26, 2025
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="gt-single-sideber-widget mb-0">
                                    <div class="gt-widget-title">
                                        <h3>Popular Tags</h3>
                                    </div>
                                    <div class="tagcloud">
                                        <a href="news-details.html">SmartHomes</a>     
                                        <a href="news-details.html">GreenLiving</a>
                                        <a href="news-details.html">LuxuryLiving</a>
                                        <a href="news-details.html">LegalAdvice</a>
                                        <a href="news-details.html">RealEstateTrends</a>
                                        <a href="news-details.html">HouseHunting</a>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                </div>
                </div>
            </div>
        </section>
        <Footer />
    </div>
  )
}

export default Blogdetail